import React from "react";
import "./Career.css";

function Career() {
  return (
    <section className="career-section" id="careers">

      {/* BACKGROUND */}
      <div className="career-noise"></div>

      <div className="career-blur career-blur1"></div>
      <div className="career-blur career-blur2"></div>

      <div className="career-container">

        {/* ================= HEADER ================= */}

        <div className="career-header">

          <div className="career-tag">
            <span></span>
            CAREERS
            <span></span>
          </div>

          <h2 className="career-heading">
            Come for the work.
            <br />
            <em>Stay for the culture.</em>
          </h2>

          <p className="career-subtitle">
            We are always looking for curious people
            <br />
            who have something interesting to say.
          </p>

        </div>


        {/* ================= MAIN CONTENT ================= */}

        <div className="career-grid">

          {/* LEFT */}

          <div className="career-intro">

            <div className="career-kicker">
              <span>WHY US</span>
              <div></div>
            </div>

            <h3>
              Good ideas need
              <br />
              <em>good people.</em>
            </h3>

            <p>
              The Culture Capsule is always on the lookout
              for people who can spot a good story, question
              a bad brief, and survive a meeting where
              someone says,
              <span className="quote">
                “I have a crazy idea...”
              </span>
            </p>

            <p>
              Our office runs on curiosity, caffeine,
              healthy debates, and the occasional existential
              discussion about why people buy what they buy.
            </p>

          </div>


          {/* RIGHT */}

          <div className="career-story">

            <div className="career-card">

              <div className="career-card-top">
                <span>THE CULTURE CAPSULE</span>
                <span>01</span>
              </div>

              <div className="career-card-content">

                <p>
                  Everyone here keeps saying they hired me
                  for my writing, but I think it was my hugs.
                </p>

                <p>
                  If you join us, I promise a warm, nurturing
                  workplace, people who genuinely care about
                  your growth, and at least one person who'll
                  get unnecessarily excited every time you
                  have a good idea.
                </p>

                <div className="career-highlight">
                  <span className="highlight-line"></span>

                  <p>
                    That's me.
                    <br />
                    <em>I'm that person.</em>
                  </p>
                </div>

              </div>

            </div>

          </div>

        </div>


        {/* ================= ROLE ================= */}

        <div className="career-role">

          <div className="role-number">
            01
          </div>

          <div className="role-main">

            <div className="role-top">
              <span>OPEN ROLE</span>
              <span>CREATIVE</span>
            </div>

            <h3>
              Copy Intern
            </h3>

            <p>
              The Hero you need,
              <br />
              and the one you deserve.
            </p>

          </div>

          <a
            href="#contact"
            className="career-apply"
          >
            Apply Now
            <span>↗</span>
          </a>

        </div>


        {/* ================= BOTTOM CTA ================= */}

        <div className="career-bottom">

          <div className="career-bottom-line"></div>

          <p>
            IF THIS SOUNDS LIKE
            <span> YOUR KIND OF WORKPLACE,</span>
          </p>

          <div className="career-bottom-line"></div>

        </div>

        <div className="career-cta">

          <h3>
            We'd love
            <em> to meet you.</em>
          </h3>

          <a href="#contact">
            Connect with Culture
            <span>↗</span>
          </a>

        </div>

      </div>

    </section>
  );
}

export default Career;